import { memo, useState } from 'react'
import { Collapsible } from '@highlight/ui'
import { Brain } from 'lucide-react'
import { useLiveThinkingText } from '../../../../store/thinking-stream'

/**
 * The message tree's comparators drop per-token thinking renders, so this leaf
 * cannot rely on `content` staying current while the turn streams. It
 * subscribes to the thinking store itself — a quarantined leaf — and falls
 * back to the prop for history and for messages the store no longer tracks.
 */
export const ThinkingPart = memo(function ThinkingPart({
  content,
  messageId,
}: {
  content: string
  messageId?: string
}) {
  const [open, setOpen] = useState(false)
  const liveContent = useLiveThinkingText(messageId, content)

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <Collapsible.Trigger
        className="flex w-full min-w-0 items-center justify-start gap-1.5 p-0 py-1.5 text-[12px] font-normal"
        showIcon={false}
      >
        <Brain size={14} className="text-foreground-secondary shrink-0" strokeWidth={2.25} />
        <span className="text-foreground-secondary min-w-0 truncate text-[12px] leading-4">Reasoning</span>
      </Collapsible.Trigger>
      <Collapsible.Content innerClassName="mt-0 gap-0">
        <div className="text-foreground-placeholder pb-1.5 pl-5 text-[12px] leading-[18px]">{liveContent}</div>
      </Collapsible.Content>
    </Collapsible>
  )
})
